import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionsFeedback from '../actions/feedback';

const initState = {};

const feedback = handleActions(
  {
    [actionsFeedback.sendMessageFeedback]: state => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [actionsFeedback.sendMessageFeedbackSuccess]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        success: state.success ? state.success + 1 : 1,
      };
    },
    [actionsFeedback.sendMessageFeedbackError]: (state, _action) => {
      return {
        ...state,
        error: true,
        errorMessage: '',
        isLoading: false,
      };
    },
  },
  initState
);
const Feedback = combineReducers({
  feedback,
});
export { Feedback };
